"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4786],{

/***/ 34786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgX = function SvgX(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m15.707 12.297 7.816-8.89h-1.855l-6.785 7.722L9.46 3.406H3.21l8.195 11.676-8.195 9.324h1.852l7.167-8.152 5.723 8.152h6.258Zm-2.539 2.89-.828-1.167-6.613-9.247H8.57l5.336 7.461.832 1.164 6.934 9.707h-2.844Zm0 0"
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgX);

/***/ })

}]);